/* Optional enhancements. All article copy and examples are readable without JS. */
(() => {
  const search = document.querySelector('[data-article-search]');
  const rows = [...document.querySelectorAll('[data-search]')];
  const searchStatus = document.querySelector('[data-search-status]');
  if (search && searchStatus) {
    function applySearch() {
      const query = search.value.trim().toLowerCase();
      let count = 0;
      for (const row of rows) {
        row.hidden = !row.dataset.search.includes(query);
        if (!row.hidden) count++;
      }
      searchStatus.textContent = count === 0
        ? 'No matching articles. Try another word or clear your search.'
        : query ? `${count} of ${rows.length} articles match.` : `${rows.length} articles available.`;
    }
    search.addEventListener('input', applySearch);
    // Browser history can restore the field after pageshow without firing input.
    window.addEventListener('pageshow', () => setTimeout(applySearch, 0));
    applySearch();
    search.disabled = false;
  }
  const numberFormat = new Intl.NumberFormat('en-US', {maximumSignificantDigits:10});
  for (const demo of document.querySelectorAll('[data-standardization]')) {
    const mass = demo.querySelector('[data-mass]');
    const percent = demo.querySelector('[data-percent]');
    const output = demo.querySelector('output');
    if (!mass || !percent || !output) continue;
    mass.disabled = false;
    percent.disabled = false;
    function update() {
      const m = mass.valueAsNumber, p = percent.valueAsNumber;
      const invalidMass = !Number.isFinite(m) || !mass.validity.valid || m < 1 || m > 10000;
      const invalidPercent = !Number.isFinite(p) || !percent.validity.valid || p < 0 || p > 100;
      mass.setAttribute('aria-invalid', String(invalidMass));
      percent.setAttribute('aria-invalid', String(invalidPercent));
      if (invalidMass || invalidPercent) {
        output.textContent = 'Enter a whole-number extract mass from 1–10,000 mg and a percentage from 0–100 (up to one decimal place).';
        return;
      }
      const result = document.createElement('strong');
      result.textContent = `${numberFormat.format(m * p / 100)} mg`;
      output.replaceChildren(`${numberFormat.format(m)} mg × ${numberFormat.format(p / 100)} = `, result, ' of the named constituent');
    }
    mass.addEventListener('input', update);
    percent.addEventListener('input', update);
  }
  const sections = [...document.querySelectorAll('.article-body section[id]')];
  if (sections.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) {
        document.querySelectorAll('.contents a').forEach(link => {
          if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
    }, {rootMargin:'-12% 0px -62% 0px'});
    sections.forEach(section => observer.observe(section));
  }
})();
